var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirmation",class:{
    'confirmation--offline': _vm.offline,
  }},[_c('div',{staticClass:"confirmation__icon-wrapper"},[_c('img',{staticClass:"confirmation__icon",attrs:{"src":_vm.icon}})]),_c('h1',{staticClass:"confirmation__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"confirmation__description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }